import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import { imports } from '../code-blocks';
import CodeBlock from '../CodeBlock';

export const Imports = () => {
	return (
		<Box my="20px">
			<Text fontSize="2xl" fontWeight="bold" py="10px">
				Imports
			</Text>
			<Text pb="10px">Import the Component and CSS file like below</Text>
			<Box>
				<CodeBlock text={imports} language="jsx" />
			</Box>
		</Box>
	);
};
